import {ObjectDirective} from "vue";

export default {
    updated(el, binding) {
        el.disabled = binding.value
    }
} as ObjectDirective